import { render, staticRenderFns } from "./ShelfSkewPicker.vue?vue&type=template&id=5de406a6&scoped=true"
import script from "./ShelfSkewPicker.vue?vue&type=script&lang=js"
export * from "./ShelfSkewPicker.vue?vue&type=script&lang=js"
import style0 from "./ShelfSkewPicker.vue?vue&type=style&index=0&id=5de406a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de406a6",
  null
  
)

export default component.exports